import { FormControl } from "@mui/material"
import { memo, useCallback } from "react"
import { useTranslation } from "react-i18next"
import CustomAsyncAutocomplete from "../../../../../core-components/theme/components/CustomAsyncAutoComplete"

interface PlantSectionProps {
  value: any
  defaultOptions?: any[]
  error?: string
  disabled?: boolean
  onChange: (value: string[]) => void
}

const PlantSection = memo(({ value, defaultOptions, error, disabled, onChange }: PlantSectionProps) => {
  const { t } = useTranslation();
  const handlePlantSelect = useCallback((selectedValue: any) => {
    onChange(selectedValue || []);
  }, [onChange]);

  const renderOption = useCallback((option: any) => (
    <div>
      <div style={{ fontWeight: 500 }}>{option.plantName}</div>
      <div style={{ fontSize: "0.875rem", color: "#666" }}>
        {option.plantType} • {option.plantNickName}
      </div>
    </div>
  ), []);

  return (
    <FormControl fullWidth error={!!error}>
      <CustomAsyncAutocomplete
        label={t('escalation.plants', 'Plant(s)')}
        placeholder={t('escalation.selectPlants', 'Select plants...')}
        value={value}
        defaultOptions={defaultOptions}
        labelKey="plantName"
        mainKey="_id"
        multiple
        disabled={disabled}
        onSelect={handlePlantSelect}
        error={!!error}
        errorText={error}
        renderCustomOption={renderOption}
      />
    </FormControl>
  )
})

export default PlantSection;